export const isProdDomain = () => {
  let url = "";
  if (typeof document !== "undefined") {
    url = window.location.href;
  }
  const domainRegex = /^(https:\/\/)(?:[^.]+\.)?telepass\.com(\/.*)?$/;
  return domainRegex.test(url);
};

type GetIdCaptchaResponse = {
  idCaptcha: string;
  domainProd: boolean;
};

export const getIdCaptcha = (
  captchaSmsProd: string,
  captchaSmsTest: string,
): GetIdCaptchaResponse => {
  const domainProd = isProdDomain();

  const idCaptcha = domainProd ? captchaSmsProd : captchaSmsTest;

  return {
    idCaptcha,
    domainProd,
  };
};
